const LABELS = {
  active: 'Active',
  draft: 'Draft',
  on_hold: 'On hold',
  done: 'Completed',
  cancelled: 'Cancelled',
  open: 'Open',
  in_progress: 'In progress',
  pending: 'Pending',
  past_due: 'Past due',
  inactive: 'Inactive',
  canceled: 'Canceled',
  trialing: 'Trialing',
};

export function statusLabel(status) {
  if (!status) {
    return '—';
  }
  return LABELS[status] || String(status).replace(/_/g, ' ');
}

export function statusTone(status) {
  switch (status) {
    case 'active':
    case 'full':
    case 'trialing':
      return 'success';
    case 'done':
      return 'rose';
    case 'on_hold':
    case 'pending':
    case 'open':
    case 'partial':
    case 'inactive':
      return 'warning';
    case 'cancelled':
    case 'canceled':
    case 'none':
    case 'past_due':
      return 'danger';
    case 'in_progress':
    case 'draft':
      return 'info';
    default:
      return 'neutral';
  }
}

export function projectProgress(status) {
  switch (status) {
    case 'active':
      return 60;
    case 'on_hold':
      return 40;
    case 'done':
      return 100;
    case 'cancelled':
      return 0;
    default:
      return 15;
  }
}

const STAGES = ['Discovery', 'Content Planning', 'Design', 'Development', 'Client Review', 'Launch'];

export function projectStages(status) {
  const currentIndex =
    {
      draft: 0,
      active: 3,
      on_hold: 2,
      done: 5,
      cancelled: -1,
    }[status] ?? 1;

  return STAGES.map((name, index) => ({
    name,
    state: currentIndex < 0 ? 'upcoming' : index < currentIndex ? 'done' : index === currentIndex ? 'current' : 'upcoming',
  }));
}

export function planTone(name) {
  const n = String(name || '').toLowerCase();
  if (n.includes('agency')) {
    return 'purple';
  }
  if (n.includes('pro')) {
    return 'purple';
  }
  if (n.includes('start') || n.includes('trial')) {
    return 'info';
  }
  return 'neutral';
}

/** Green = on track / ViiB working, yellow = waiting on client, red = action required, blue = review. */
export function projectHealth(project) {
  const status = project?.status;
  const overdue = Boolean(project?.is_overdue) || isPastDue(project?.due_date, status);
  if (overdue) {
    return { label: 'Action Required', tone: 'danger', detail: 'Overdue' };
  }
  if (status === 'on_hold' || project?.waiting_on_client) {
    return { label: 'Waiting on Client', tone: 'warning', detail: 'Waiting on client' };
  }
  if (status === 'active') {
    return { label: 'ACTIVE', tone: 'success', detail: 'ViiB Working' };
  }
  if (status === 'draft') {
    return { label: 'Needs Review', tone: 'info', detail: 'In review' };
  }
  if (status === 'done') {
    return { label: 'Completed', tone: 'rose', detail: 'On track' };
  }
  return { label: statusLabel(status), tone: statusTone(status), detail: statusLabel(status) };
}

function isPastDue(dueDate, status) {
  if (!dueDate || ['done', 'cancelled', 'canceled'].includes(status)) {
    return false;
  }
  return String(dueDate).slice(0, 10) < new Date().toISOString().slice(0, 10);
}
